import React from 'react';
import Helmet from 'react-helmet';
import * as _ from 'lodash';
import Moment from 'moment';

// Components
import ReactDropDownCalender from '../components/ReactDropDownCalender';
import { CsvCompanyBranchDropdownMulti } from '../components/dropdowns/multi/CsvCompanyBranch';
import { CsvFieldDropdownMulti } from '../components/dropdowns/multi/CsvField';
import { Confirmation, Information } from '../components/modals/common';
import { Description } from '../components/Description';

// Services
import { OutputCsvProcessingsService } from '../services/OutputCsvProcessings';

// Utilities
import {
  HEADER_CONSTANTS,
  REQUEST_PARAMS,
  WORK_TYPE,
} from '../utilities/constants';
import { UserProfileService } from '../services/UserProfiles';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import csvRequestSchema from '../utilities/validationSchemas/csvRequest';
import masterSlideLoader from '../utilities/masterSlideLoader';
import { messageUtility } from '../utilities/messageUtility';
import { validateByJoi } from '../utilities/validation';
import { MasterPageHeader } from '../components/PageHeader';
import {
  FormElement,
  FormElementContainer,
  FormElementContainerItem,
  FormList,
  FormListItem,
  FormListSubHeader,
} from '../components/CommonFormComponents';
import { RadioButtonIcon } from '../components/icons/RadioButtonIcon';
import { isBranchRoleId, isPrimeRoleId } from '../utilities/roleUtility';
import { CompanyBranchService } from '../services/CompanyBranches';

export default class CSVRequest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      roleId: LocalStorageService.getRoleId(),
      companyBranchName: '',
      branchList: [],
      dialogShow: false,
      errorDialogShow: false,
      fieldList: [],
      formValues: {
        csv_type: WORK_TYPE.WORK_SCHEDULE.ID,
        company_branch_ids: [],
        field_ids: [],
        from_date: '',
        to_date: '',
      },
      isPermitted: false,
      selectedBranches: [],
      selectedFields: [],
      selectAllBranches: false,
      selectAllFields: false,
      pageTitle: 'CSVデータ出力',
      requiredInput: {
        // 必須項目
        columns: [
          'company_branch_ids',
          'csv_type',
          'field_ids',
          'from_date',
          'to_date',
        ],
        count: 2,
        total: 4,
      },
      validate: {
        invalid: false, // 入力内容エラー
        validated: false,
        messages: {}, // エラー内容
      },
      isRegisterWaiting: false, // 連打防止用
    };
    this.schema = csvRequestSchema;

    this.onChangeValue = this.onChangeValue.bind(this);
    this.resetValues = this.resetValues.bind(this);
    this.selectAllBranches = this.selectAllBranches.bind(this);
    this.selectAllFields = this.selectAllFields.bind(this);
    this.setValue = this.setValue.bind(this);
    this.submit = this.submit.bind(this);
    this.validate = this.validate.bind(this);
  }

  checkPermission = () => {
    const userId = LocalStorageService.getItem('user_id');
    UserProfileService.show(userId, {}).then(response => {
      if (!response.result) {
        return;
      } else {
        const useOutputCsvProcessingFlg =
          response.data.entities.user_profile.use_output_csv_processing_flg;
        if (useOutputCsvProcessingFlg === false) {
          this.setState({
            errorDialogShow: true,
          });
        } else {
          this.setState({
            isPermitted: true,
          });
        }
      }
    });
  };

  handleChangeDate = (name, value) => {
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          [name]: value,
        },
      },
      () => {
        this.validateValue('date');
      }
    );
  };

  getAbsoluteMonths = date => {
    const months = Number(date.format('MM'));
    const years = Number(date.format('YYYY'));
    return months + years * 12;
  };

  validateDate = () => {
    const { from_date, to_date } = this.state.formValues;
    if (
      this.getAbsoluteMonths(Moment(to_date)) -
        this.getAbsoluteMonths(Moment(from_date)) >
      3
    ) {
      return '3ヶ月間を超える期間は選択できません';
    }

    if (
      this.getAbsoluteMonths(Moment(to_date)) -
        this.getAbsoluteMonths(Moment(from_date)) ===
        3 &&
      Number(Moment(to_date).format('D')) >
        Number(Moment(from_date).format('D'))
    ) {
      return '3ヶ月間を超える期間は選択できません';
    }

    if (Moment(from_date).isAfter(to_date)) {
      return '開始日が終了日より後の日付になっています。';
    }

    return '';
  };

  onChangeValue(event) {
    const { formValues } = _.cloneDeep(this.state);
    formValues[event.target.name] = parseInt(event.target.value);
    this.setState({ formValues });
  }

  // branchList, fieldListのstate更新
  setList = (key, list) => {
    this.setState({
      [key]: _.uniqWith(_.concat(this.state[key], list), _.isEqual),
    });
  };

  setValue = (key, value) => {
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          [key]: value,
        },
      },
      () => {
        this.validateValue(key, value);
        this.checkRequired();
      }
    );
  };

  validateValue = (key, value) => {
    const { validate } = _.cloneDeep(this.state);
    if (key === 'date') {
      if (this.validateDate() !== '') {
        validate.invalid = true;
        validate.messages = {
          ...validate.messages,
          to_date: this.validateDate(),
        };
      }
      if (this.validateDate() === '' && _.has(validate.messages, 'to_date')) {
        delete validate.messages.to_date;
      }
    }
    if (key === 'company_branch_ids') {
      const validation = validateByJoi(csvRequestSchema, {
        [key]: value,
      });
      if (_.has(validation.messages, key) && !this.state.selectAllBranches) {
        validate.invalid = true;
        validate.messages = {
          ...validate.messages,
          company_branch_ids: '支店を選択してください。',
        };
      } else {
        delete validate.messages.company_branch_ids;
      }
    }
    if (key === 'field_ids') {
      const validation = validateByJoi(csvRequestSchema, {
        [key]: value,
      });
      if (_.has(validation.messages, key) && !this.state.selectAllFields) {
        validate.invalid = true;
        validate.messages = {
          ...validate.messages,
          field_ids: '現場を選択してください。',
        };
      } else {
        delete validate.messages.field_ids;
      }
    }

    validate.invalid = _.size(validate.messages) > 0;
    this.setState({ validate }, () => {
      this.checkRequired();
    });
  };

  selectAllBranches = () => {
    let { formValues, requiredInput } = _.cloneDeep(this.state);
    formValues.company_branch_ids = [];

    this.setState(
      {
        formValues,
        requiredInput,
        selectAllBranches: true,
      },
      () => {
        this.validateValue('company_branch_ids');
      }
    );
  };

  selectAllFields = () => {
    const { formValues, requiredInput } = _.cloneDeep(this.state);
    formValues.field_ids = [];

    this.setState(
      {
        formValues,
        requiredInput,
        selectAllFields: true,
      },
      () => {
        this.validateValue('field_ids');
      }
    );
  };

  checkRequired() {
    const validation = validateByJoi(csvRequestSchema, this.state.formValues);
    const { messages } = _.cloneDeep(this.state.validate);
    if (_.isUndefined(validation.messages)) {
      validation.messages = {};
    }
    if (
      _.has(validation.messages, 'company_branch_ids') &&
      this.state.selectAllBranches === true
    ) {
      delete validation.messages.company_branch_ids;
    }
    if (
      _.has(validation.messages, 'field_ids') &&
      this.state.selectAllFields === true
    ) {
      delete validation.messages.field_ids;
    }
    if (_.has(messages, 'to_date')) {
      validation.messages.to_date = messages.to_date;
    }
    if (_.size(validation.messages) === 0) {
      validation.result = true;
    }
    this.setState({
      requiredInput: {
        ...this.state.requiredInput,
        count: this.state.requiredInput.total - _.size(validation.messages),
      },
    });
  }

  validate() {
    const validation = validateByJoi(csvRequestSchema, this.state.formValues);
    if (this.validateDate() !== '') {
      validation.result = false;
      validation.messages.to_date = this.validateDate();
    }
    if (
      _.has(validation.messages, 'company_branch_ids') &&
      this.state.selectAllBranches === true
    ) {
      delete validation.messages.company_branch_ids;
    }
    if (
      _.has(validation.messages, 'field_ids') &&
      this.state.selectAllFields === true
    ) {
      delete validation.messages.field_ids;
    }
    if (_.size(validation.messages) === 0) {
      validation.result = true;
    }
    this.setState({
      validate: {
        invalid: !validation.result,
        messages: validation.messages ? validation.messages : {},
        validated: true,
      },
    });
    return validation.result;
  }

  resetValues() {
    const today = Moment().format('YYYY/MM/DD');
    const { company_branch_ids } = _.cloneDeep(this.state.formValues);
    this.setState(
      {
        dialogShow: false,
        formValues: {
          csv_type: WORK_TYPE.WORK_SCHEDULE.ID,
          company_branch_ids: [],
          field_ids: [],
          from_date: today,
          to_date: today,
        },
        requiredInput: {
          ...this.state.requiredInput,
          count:
            isBranchRoleId(this.state.roleId) &&
            !_.isEmpty(this.state.branchList)
              ? 3
              : 2,
        },
        selectedBranches: [],
        selectedFields: [],
        selectAllBranches: false,
        selectAllFields: false,
        validate: {
          invalid: false,
          validated: false,
          messages: {},
        },
      },
      () => {
        if (isBranchRoleId(this.state.roleId)) {
          this.setState({
            formValues: {
              ...this.state.formValues,
              company_branch_ids,
            },
          });
        }
      }
    );
  }

  setBranchList = () => {
    if (isBranchRoleId(this.state.roleId)) {
      const params = {
        limit: REQUEST_PARAMS.parentLimit,
        offset: 0,
        name: '',
        isQuiet: true,
      };
      CompanyBranchService.listForOutputCsv(params).then(response => {
        if (response.result) {
          const branches = response.data.entities.company_branches;
          this.setList('branchList', branches);
        }
      });
    }
  };

  submit() {
    if (this.state.isRegisterWaiting || !this.validate()) {
      return;
    } else {
      this.setState({ isRegisterWaiting: true }, async () => {
        const result = await this.validate();
        if (!result) {
          this.setState(
            {
              isRegisterWaiting: false,
            },
            () => {
              return;
            }
          );
        }
        const data = _.cloneDeep(this.state.formValues);
        if (this.state.selectAllBranches) {
          delete data.company_branch_ids;
        }
        if (this.state.selectAllFields) {
          delete data.field_ids;
        }
        // APIでは「日付」がハイフン形式のため変換する
        data.from_date = Moment(data.from_date).format('YYYY-MM-DD');
        data.to_date = Moment(data.to_date).format('YYYY-MM-DD');
        OutputCsvProcessingsService.create(data)
          .then(response => {
            if (!response.result) {
              return;
            }
            this.setState({
              dialogShow: true,
            });
          })
          .finally(() => {
            this.setState({ isRegisterWaiting: false });
          });
      });
    }
  }

  async componentDidMount() {
    this.checkPermission();
    this.resetValues();
    this.setBranchList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !_.isEqual(
        prevState.formValues.company_branch_ids,
        this.state.formValues.company_branch_ids
      )
    ) {
      const selectedBranches = _.filter(this.state.branchList, branch => {
        return _.includes(this.state.formValues.company_branch_ids, branch.id);
      });
      const removedBranches = _.uniq(
        _.difference(prevState.selectedBranches, selectedBranches)
      );
      let removingFields = [];
      _.each(this.state.selectedFields, field => {
        if (
          _.find(removedBranches, branch => {
            return branch.id === field.company_branch_id;
          })
        ) {
          removingFields.push(field);
        }
      });
      const selectedFields = _.difference(
        this.state.selectedFields,
        removingFields
      );
      let field_ids = [];
      _.each(selectedFields, field => {
        field_ids.push(field.id);
      });
      this.setState({
        formValues: {
          ...this.state.formValues,
          field_ids,
        },
        selectedBranches,
        selectedFields,
      });
    }
    // selectedFields更新
    if (
      !_.isEqual(
        prevState.formValues.field_ids,
        this.state.formValues.field_ids
      )
    ) {
      const selectedFields = _.filter(this.state.fieldList, field => {
        return _.includes(this.state.formValues.field_ids, field.id);
      });
      this.setState({ selectedFields });
    }
    if (!_.isEqual(prevState.branchList, this.state.branchList)) {
      const companyBranchName = _.get(
        _.find(this.state.branchList, branch => {
          return branch.id === Number(SessionStorageService.getCompanyBranchId());
        }),
        'name'
      );

      let { company_branch_ids } = _.cloneDeep(this.state.formValues);
      if (this.state.branchList.length === 1) {
        company_branch_ids = [this.state.branchList[0]['id']];
      }

      this.setState(
        {
          companyBranchName,
          formValues: {
            ...this.state.formValues,
            company_branch_ids,
          },
        },
        () => {
          this.checkRequired();
        }
      );
    }
  }

  shouldComponentUpdate(nextProps) {
    if (
      !_.isUndefined(this.props.formValues) &&
      !_.isEqual(
        this.props.formValues.field_ids,
        nextProps.formValues.field_ids
      )
    ) {
      return false;
    } else {
      return true;
    }
  }

  render() {
    const {
      dialogShow,
      formValues,
      isPermitted,
      pageTitle,
      validate,
    } = this.state;
    const { messages } = validate;
    const dialogMessage = (
      <p>
        ただいまCSVファイルを出力しています。 <br />
        ファイルの出力には少々お時間をいただく場合があります。
        <br />
        出力が完了しましたら、メールにてご連絡いたします。 <br />
        CSVダウンロードへ進み、データのダウンロードを行ってください。
      </p>
    );

    return (
      <div className='master-slide-view show CsvRequest'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.conference} - {pageTitle}
          </title>
        </Helmet>
        <div className='master-slide-view__view'>
          {isPermitted && (
            <React.Fragment>
              <MasterPageHeader
                title={pageTitle}
                onClose={() => masterSlideLoader.close()}
              />
              <div className='contruction-slide-view__body'>
                <div className='contruction-detail-view'>
                  <div className='contruction-detail-view__sidemenu'>
                    <ul className='contruction-navi-list'>
                      <li className='contruction-navi-list__item'>
                        <div
                          className={
                            'line-list line-list--contruction-navi-list select'
                          }
                          onClick={() => {
                            masterSlideLoader.show('CsvRequest', {
                              state: {},
                            });
                          }}
                        >
                          CSV出力依頼
                        </div>
                      </li>
                      <li className='contruction-navi-list__item'>
                        <div
                          className='line-list line-list--contruction-navi-list'
                          onClick={() => {
                            masterSlideLoader.show('CsvList', {
                              state: {},
                            });
                          }}
                        >
                          CSVダウンロード
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                    <div
                      className='contruction-detail-view__menu'
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span className='construction-detail-view__button'>
                        <button
                          className={validate.invalid ? 'btn--disabled' : 'btn'}
                          disabled={validate.invalid}
                          onClick={this.submit}
                        >
                          CSV出力依頼
                        </button>
                      </span>
                      <div className='csv-form__required-count'>
                        <div className='form-list__header-alert show'>
                          {this.state.validate.invalid
                            ? '入力エラーがあります。'
                            : ''}
                        </div>
                        <p className='csv-form__required-count-text'>
                          必須項目の入力数 {this.state.requiredInput.count}/
                          {this.state.requiredInput.total}
                        </p>
                      </div>
                    </div>
                    <div className='contruction-detail-view__bar' />
                    <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix'>
                      <form className='csv-form'>
                        <div className='csv-form__description'>
                          <Description>
                            <p>
                              CSVファイルをダウンロードするためには、まずこちらの画面からCSVファイルの出力依頼を行ってください。
                            </p>
                            <p>
                              出力が完了しましたらCSVダウンロード画面の一覧からダウンロードすることができます。
                            </p>
                          </Description>
                        </div>
                        <FormList>
                          <FormListSubHeader
                            title='データ抽出条件'
                            noMarginTop={true}
                            info={
                              <button
                                className='btn-text--sm'
                                onClick={this.resetValues}
                                type='button'
                              >
                                抽出条件をクリア
                              </button>
                            }
                          />
                          <FormListItem label='対象情報' required={true}>
                            <FormElement validate={_.get(messages, 'csv_type')}>
                              <div className='form-list-radio__item'>
                                <label
                                  htmlFor='form-work-schedule'
                                  className='radio'
                                >
                                  <input
                                    name='csv_type'
                                    checked={
                                      formValues.csv_type ===
                                      WORK_TYPE.WORK_SCHEDULE.ID
                                    }
                                    type='radio'
                                    value={WORK_TYPE.WORK_SCHEDULE.ID}
                                    id='form-work-schedule'
                                    onChange={this.onChangeValue}
                                  />
                                  <RadioButtonIcon className='icon--2x' />
                                  <span>{WORK_TYPE.WORK_SCHEDULE.NAME}</span>
                                </label>
                              </div>
                              <div className='form-list-radio__item'>
                                <label
                                  htmlFor='form-work-result'
                                  className='radio'
                                >
                                  <input
                                    name='csv_type'
                                    type='radio'
                                    value={WORK_TYPE.WORK_RESULT.ID}
                                    checked={
                                      formValues.csv_type ===
                                      WORK_TYPE.WORK_RESULT.ID
                                    }
                                    id='form-work-result'
                                    onChange={this.onChangeValue}
                                  />
                                  <RadioButtonIcon className='icon--2x' />
                                  <span>{WORK_TYPE.WORK_RESULT.NAME}</span>
                                </label>
                              </div>
                            </FormElement>
                          </FormListItem>
                          <FormListItem label='期間' required={true}>
                            <FormElement validate={_.get(messages, 'to_date')}>
                              <div className='input-date-range'>
                                <ReactDropDownCalender
                                  onChange={date =>
                                    this.handleChangeDate('from_date', date)
                                  }
                                  value={this.state.formValues.from_date}
                                  format={'YYYY/MM/DD'}
                                />
                                <span className='input-date-range__bar'>
                                  〜
                                </span>
                                <ReactDropDownCalender
                                  onChange={date =>
                                    this.handleChangeDate('to_date', date)
                                  }
                                  value={this.state.formValues.to_date}
                                  format={'YYYY/MM/DD'}
                                />
                              </div>
                            </FormElement>
                          </FormListItem>
                          <FormListItem label='支店' required={true}>
                            <FormElement
                              validate={
                                _.has(messages, 'company_branch_ids') &&
                                '支店を選択してください。'
                              }
                            >
                              <FormElementContainer>
                                {isPrimeRoleId(this.state.roleId) && (
                                  <FormElementContainerItem>
                                    <div className='form-list-radio__item form-list-radio__item-wrap'>
                                      <label className='radio'>
                                        <input
                                          name='branch'
                                          checked={
                                            !this.state.selectAllBranches
                                          }
                                          type='radio'
                                          id='form-branch-select'
                                          onChange={() => {
                                            this.setState(
                                              {
                                                formValues: {
                                                  ...this.state.formValues,
                                                  company_branch_ids: [],
                                                  field_ids: [],
                                                },
                                                selectedBranches: [],
                                                selectedFields: [],
                                                selectAllBranches: false,
                                                validate: {
                                                  invalid: false,
                                                  validated: false,
                                                  messages: {},
                                                },
                                              },
                                              () => {
                                                this.checkRequired();
                                              }
                                            );
                                          }}
                                        />
                                        <RadioButtonIcon className='icon--2x' />
                                        <span>支店を選択する</span>
                                      </label>
                                      {!this.state.selectAllBranches && (
                                        <div className='csv-form__dropdown'>
                                          <CsvCompanyBranchDropdownMulti
                                            isPermitted={this.state.isPermitted}
                                            setList={this.setList}
                                            selected={
                                              this.state.formValues
                                                .company_branch_ids
                                            }
                                            selectedBranches={
                                              this.state.selectedBranches
                                            }
                                            set={this.setValue}
                                          />
                                          <span>※複数選択可能</span>
                                        </div>
                                      )}
                                    </div>
                                  </FormElementContainerItem>
                                )}
                                {isPrimeRoleId(this.state.roleId) && (
                                  <FormElementContainerItem>
                                    <div className='form-list-radio__item'>
                                      <label className='radio'>
                                        <input
                                          name='branch'
                                          checked={this.state.selectAllBranches}
                                          type='radio'
                                          id='form-branch-all'
                                          onChange={this.selectAllBranches}
                                        />
                                        <RadioButtonIcon className='icon--2x' />
                                        <span>すべての支店を選択する</span>
                                      </label>
                                    </div>
                                  </FormElementContainerItem>
                                )}
                                {isBranchRoleId(this.state.roleId) &&
                                  !_.isEmpty(this.state.branchList) && (
                                    <p className='form-container__static-item'>
                                      {this.state.companyBranchName}
                                    </p>
                                  )}
                              </FormElementContainer>
                            </FormElement>
                          </FormListItem>
                          <FormListItem label='現場' required={true}>
                            <FormElement
                              validate={
                                _.has(messages, 'field_ids') &&
                                '現場を選択してください。'
                              }
                            >
                              <FormElementContainer>
                                <FormElementContainerItem>
                                  <div className='form-list-radio__item form-list-radio__item-wrap'>
                                    <label className='radio'>
                                      <input
                                        name='field'
                                        checked={!this.state.selectAllFields}
                                        type='radio'
                                        id='form-field-select'
                                        onChange={() => {
                                          this.setState(
                                            {
                                              selectAllFields: false,
                                            },
                                            () => {
                                              this.checkRequired();
                                            }
                                          );
                                        }}
                                      />
                                      <RadioButtonIcon className='icon--2x' />
                                      <span>現場を選択する</span>
                                    </label>
                                    {!this.state.selectAllFields && (
                                      <div className='csv-form__dropdown'>
                                        <CsvFieldDropdownMulti
                                          branchIds={
                                            this.state.formValues
                                              .company_branch_ids
                                          }
                                          isPermitted={this.state.isPermitted}
                                          selected={
                                            this.state.formValues.field_ids
                                          }
                                          selectedBranches={
                                            this.state.selectedBranches
                                          }
                                          selectedFields={
                                            this.state.selectedFields
                                          }
                                          selectAllBranches={
                                            this.state.selectAllBranches
                                          }
                                          set={this.setValue}
                                          setList={this.setList}
                                        />
                                        <span>※複数選択可能</span>
                                      </div>
                                    )}
                                  </div>
                                </FormElementContainerItem>
                                <FormElementContainerItem>
                                  <div className='form-list-radio__item'>
                                    <label className='radio'>
                                      <input
                                        name='field'
                                        type='radio'
                                        checked={this.state.selectAllFields}
                                        id='form-field-all'
                                        onChange={this.selectAllFields}
                                      />
                                      <RadioButtonIcon className='icon--2x' />
                                      <span>すべての現場を選択する</span>
                                    </label>
                                  </div>
                                </FormElementContainerItem>
                              </FormElementContainer>
                            </FormElement>
                          </FormListItem>
                          <div className='form-list__item'>
                            <div className='form-list__label' />
                            <div className='form-list__element form-list__element--column'>
                              <div className='form-list__element-row'>
                                <div className='selected-list'>
                                  {this.state.selectAllBranches &&
                                    this.state.selectAllFields && (
                                      <React.Fragment>
                                        <p className='selected-list__title'>
                                          選択中の支店一覧
                                        </p>
                                        <ul className='selected-list__list'>
                                          <li className='selected-list__item'>
                                            <span className='selected-list__name'>
                                              すべての支店
                                            </span>
                                          </li>
                                        </ul>
                                      </React.Fragment>
                                    )}
                                  {!this.state.selectAllBranches &&
                                    this.state.selectAllFields && (
                                      <React.Fragment>
                                        <p className='selected-list__title'>
                                          選択中の支店一覧
                                        </p>
                                        <ul className='selected-list__list'>
                                          {_.map(
                                            this.state.formValues
                                              .company_branch_ids,
                                            companyBranch => {
                                              const companyBranchItem = _.find(
                                                this.state.branchList,
                                                branchListItem => {
                                                  return (
                                                    branchListItem.id ===
                                                    companyBranch
                                                  );
                                                }
                                              );
                                              return (
                                                <li
                                                  className='selected-list__item'
                                                  key={companyBranchItem.id}
                                                >
                                                  <span className='selected-list__name'>
                                                    {companyBranchItem.name}
                                                  </span>
                                                </li>
                                              );
                                            }
                                          )}
                                        </ul>
                                      </React.Fragment>
                                    )}
                                  {this.state.selectAllBranches &&
                                    !this.state.selectAllFields && (
                                      <React.Fragment>
                                        <p className='selected-list__title'>
                                          選択中の現場一覧
                                        </p>
                                        <ul className='selected-list__list'>
                                          {_.map(
                                            this.state.formValues.field_ids,
                                            field => {
                                              const fieldItem = _.find(
                                                this.state.fieldList,
                                                fieldListItem => {
                                                  return (
                                                    fieldListItem.id === field
                                                  );
                                                }
                                              );
                                              return (
                                                <li
                                                  className='selected-list__item'
                                                  key={fieldItem.id}
                                                >
                                                  <span className='selected-list__name selected-list__name--branch'>
                                                    {
                                                      fieldItem.company_branch_name
                                                    }
                                                  </span>
                                                  <span className='selected-list__name selected-list__name--field'>
                                                    {fieldItem.name}
                                                  </span>
                                                </li>
                                              );
                                            }
                                          )}
                                        </ul>
                                      </React.Fragment>
                                    )}
                                  {!this.state.selectAllBranches &&
                                    !this.state.selectAllFields && (
                                      <React.Fragment>
                                        <p className='selected-list__title'>
                                          選択中の現場一覧
                                        </p>
                                        <ul className='selected-list__list'>
                                          {_.map(
                                            this.state.formValues.field_ids,
                                            field => {
                                              const fieldItem = _.find(
                                                this.state.fieldList,
                                                fieldListItem => {
                                                  return (
                                                    fieldListItem.id === field
                                                  );
                                                }
                                              );
                                              return (
                                                <li
                                                  className='selected-list__item'
                                                  key={fieldItem.id}
                                                >
                                                  <span className='selected-list__name selected-list__name--branch'>
                                                    {
                                                      fieldItem.company_branch_name
                                                    }
                                                  </span>
                                                  <span className='selected-list__name selected-list__name--field'>
                                                    {fieldItem.name}
                                                  </span>
                                                </li>
                                              );
                                            }
                                          )}
                                        </ul>
                                      </React.Fragment>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </FormList>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
        <Confirmation
          visible={dialogShow === true}
          title={'CSVファイルを出力しています'}
          message={dialogMessage}
          confirmButtonText={'続けて出力依頼する'}
          cancelButtonText={'CSVダウンロード'}
          onConfirm={() => {
            this.setState(
              {
                dialogShow: false,
                isRegisterWaiting: false,
              },
              () => {
                return;
              }
            );
          }}
          onCancel={() => {
            this.setState(
              {
                dialogShow: false,
                isRegisterWaiting: false,
              },
              () => {
                masterSlideLoader.show('CsvList', {
                  state: {},
                });
              }
            );
          }}
        />
        <Information
          title='CSV出力はご利用いただけません'
          message={messageUtility.getMessage('I-000-084')}
          buttonText={messageUtility.getMessage('I-000-017')}
          visible={this.state.errorDialogShow}
          onClose={() => {
            this.setState(
              {
                errorDialogShow: false,
                isRegisterWaiting: false,
              },
              () => {
                masterSlideLoader.close();
              }
            );
          }}
          multilineText={true}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CsvRequest.jsx